<template>
  <div class="wrapper h-100">
    <slot name="dimension-menu">
      <slot name="header"></slot>
      <transition name="fade-transform" mode="out-in">
        <div class="h-100" v-if="!isSelectStep" key="pre-select-step">
          <vue-fuse
            :keys="['name']"
            :list="filters"
            class="search"
            placeholder="Search"
            @fuseResultsUpdated="search"
          />
          <slot name="settings"></slot>
          <div class="content">
            <tree :tree="showFilters" @input="onInput" :uniq-key="uniqKey" />
            <p
              v-if="showFilters.length === 0"
              class="mb-0 px-3 py-2 text-light small"
            >
              {{ emptyText }}
            </p>
          </div>
        </div>
        <div v-if="isSelectStep" key="select-step">
          <div class="header wrapper pr-2 border-bottom">
            <button @click="back()" class="btn-link-alt float-right">
              <svg-icon icon="chevron-left" class="icon-sm" />
              <span style="line-height: 1;">{{ $t('back') }}</span>
            </button>
          </div>
          <div>
            <dimension-configurator
              :configuration="configuration"
              @submit="submit"
            />
          </div>
        </div>
      </transition>
    </slot>
  </div>
</template>

<script>
import DimensionConfigurator from './DimensionConfigurator.vue';

export default {
  components: {
    Tree: () => import('./Tree.vue'),
    DimensionConfigurator
  },

  props: {
    filters: {
      type: Array,
      default: () => []
    },
    uniqKey: {
      type: String,
      default: 'name'
    },
    name: {
      type: String,
      default: 'name'
    },
    customEmptyText: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      configuration: null,
      showFilters: []
    };
  },

  computed: {
    isSelectStep() {
      return Boolean(this.configuration);
    },

    emptyText() {
      return this.customEmptyText || this.$t('noResultsFound');
    }
  },

  methods: {
    onInput(value) {
      if (this.name === 'segments') {
        this.submit(value.name);
        return;
      }
      if (value.params) {
        this.submit({
          name: value.name,
          value: value.params,
          key: value.key
        });
      } else if (value.configuration) {
        this.configuration = {
          ...value.configuration,
          name: value.name,
          key: value.key
        };
      } else {
        this.submit(value);
      }
    },
    back() {
      this.configuration = null;
    },
    submit(value) {
      this.$emit('submit', value);
    },
    search(filters) {
      this.showFilters = filters;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  max-height: 253px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
@include media-breakpoint-down(md) {
  .content {
    max-height: calc(100% - 44px - 28px);
  }
}
</style>
